import React from 'react';
import LandingCard from '../landing-card';
import PasoAPaso from 'images/paso_a_paso_home.png';
import './landing-video.scss';

export default () => {
    return (
        <LandingCard className='video'>
            {/* <div className='video'>
                <iframe
                    title="intro-video"
                    width='100%'
                    height='100%'
                    src="https://www.youtube.com/embed/Ml9KrnoMixM?rel=0&enablejsapi=1&"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            </div> */}

            <div className='info'>
                <div className='text'>
                    <span className="subtitle">¿Qué es ACHS Virtual?</span>
                    <span>Renovamos nuestra plataforma digital</span>
                    <p>Renovamos nuestra plataforma digital para que todos los trabajadores y empresas adheridas a la ACHS puedan gestionar de manera ágil y sencilla datos e información relevante para la tramitación de siniestros, subsidios, descarga de certificados y prestaciones económicas, a través de la unificación de los canales digitales en un solo lugar.
                    <br /><br />
                    Repensamos nuestra plataforma para hacerla más funcional y amigable, optimizamos los procesos y fomentamos la autogestión de los usuarios mediante una navegación intuitiva, donde podrás realizar todas las transacciones necesarias para llevar a cabo una gestión sencilla y expedita con nosotros.</p>
                </div>
            </div>


        </LandingCard>
    )
}
